import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllWorkers = (name, companyId) => {
  return Api(
    `${endPoints.getAllWorkers}?name=${name || ""}&companyId=${companyId}&limit=${500}`,
    null,
    requestType.GET
  );
};

const getAllWorkerForFilters = () => {
  return Api(endPoints.getAllWorkerForFilters, null, requestType.GET);
};

const deleteWorker = (id) => {
  return Api(`${endPoints.deleteWorker}/${id}`, null, requestType.GET);
};

const getWorkerBySubservices = (payload) => {
  return Api(endPoints.getWorkerBySubservices, payload, requestType.POST);
};

export {
  getAllWorkers,
  deleteWorker,
  getAllWorkerForFilters,
  getWorkerBySubservices,
};
